const rsServicioSolicitado = [
  { value: '0', detalle: 'Nueva Carga' },
  {
    value: '1',
    detalle: 'Ampliación Carga',
  },
  {
    value: '1',
    detalle: 'Disminución de carga',
  },
  {
    value: '2',
    detalle: 'Remodelación',
  },
  {
    value: '3',
    detalle: 'Independización cuentas',
  },
  {
    value: '4',
    detalle: 'Cambio lugar armario medidores',
  },
  {
    value: '5',
    detalle: 'Cambio del punto de conexión',
  },
  {
    value: '6',
    detalle: 'Cambio nivel de tensión de suministro',
  },
  {
    value: '7',
    detalle: 'Provisional',
  },
  {
    value: '8',
    detalle: 'Otro',
  },
];

export default rsServicioSolicitado;
